<template>
    <!-- 生美激励在线排行榜/圣诞 -->
    <div class="ranking" v-if="role">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <img v-if="currentJobTab === '3' && currentGroupMillionTab === '百万大咖夺金奖'" class="banner" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/bannerManagerDk.png`" alt="banner">
            <img v-else class="banner" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/${getTheme('bannerImg')}.png`" alt="banner">
            <img class="rule" v-if="currentJobTab === '3'" @click="toRule" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/rule1.png`">

            <div class="reward-box" v-if="!(currentJobTab === '3' && currentGroupMillionTab === '自我突破奖(非百万)' && currentGroupTab === 'A组')">
                <div v-if="currentJobTab !== '3'" class="reward" :class="[`baseHeight${currentJobTab}`, { left: currentJobTab !== '1' && currentJobTab !== '3' }]" :style="{ backgroundImage: `url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/${getTheme('rewardImg')}.png)` }">
                    <div class="reward-data">
                        <img v-show="currentJobTab === '3'" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-08-01/money.png" alt="left image">
                        <div class="text">{{ getThemeBonus('rewardText1') }}</div>
                        <div class="text" v-html="getThemeBonus('rewardText2')"></div>
                    </div>
                    <div class="reward-data" v-show="currentJobTab === '1'">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-08-01/money.png" alt="right image">
                    </div>
                    <div class="reward-data" v-show="currentJobTab !== '1' && currentJobTab !== '3'">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/cash.png" alt="left image">
                    </div>
                    <div class="reward-data" v-show="currentJobTab === '3'">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-08-01/money.png" alt="right image">
                    </div>
                </div>
                <div v-else class="reward-img">
                    <div v-if="currentGroupMillionTab === '自我突破奖(百万)'">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/millionGift.png" alt="left image">
                    </div>
                    <div v-else-if="currentGroupMillionTab === '百万大咖夺金奖'">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/millionGiftEnd.png" alt="right image">
                    </div>
                    <div v-else-if="currentGroupTab !== 'A组'">
                        <img v-if="currentGroupTab == 'B组'" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/millionGiftb.png" alt="right image">
                        <img v-else-if="currentGroupTab == 'C组'" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/millionGiftc.png" alt="right image">
                        <img v-else src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/millionGiftd.png" alt="right image">
                    </div>
                </div>
                <img v-if="!myInfo" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status1.png">
                <template v-else>
                    <img v-if="!isEnd && !isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status2.png">
                    <img v-if="!isEnd && isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status33.png">
                    <img v-if="isEnd && !isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status4.png">
                    <img v-if="isEnd && isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status5.png">
                </template>
                <!-- 区域经理和主任展示 -->
                <div v-if="dataInfo?.timePer">标准激励进度：<span class="red">{{ dataInfo.timePer }}%</span></div>
                <template v-if="myInfo">
                    <p class="reach" v-if="currentJobTab !== '3'">{{ getTheme('achieve') }}{{ isReach ? '已达成' : '未达成' }}</p>
                    <div class="compare compare-center" v-if="(currentJobTab === '3' && isMillion === '0' && currentGroupTab !== 'A组') || (currentJobTab === '3' && currentGroupMillionTab == '百万大咖夺金奖')">
                        <div class="compare-data">
                            <p>我的</p>
                            <p>产品销售额</p>
                            <p class="blue">{{ myData }}
                                <span>W</span>
                            </p>
                        </div>
                    </div>
                    <div class="compare" v-else>
                        <div class="compare-data">
                            <p>{{ getTheme('leftText1') }}</p>
                            <p>{{ getTheme('leftText2') }}</p>
                            <p class="blue" v-if="currentJobTab === '4' || currentJobTab === '5'">
                                {{ myInfo.accountAmtMtd }}<span>W</span>
                                <span class="red fs-32">({{ myInfo.accountAmtTargetPer }}%)</span>
                            </p>
                            <p class="blue" v-if="currentJobTab === '3'">
                                {{ dataInfo.saleAmtBfSelfBcLm }}<span>W</span>
                            </p>
                            <p class="blue" v-if="currentJobTab === '1' || currentJobTab === '2'">{{ myData }}
                                <span v-if="currentJobTab === '1'">W</span>
                                <span v-else>%</span>
                            </p>
                        </div>
                        <img v-if="currentJobTab !== '3' && currentJobTab !== '4' && currentJobTab !== '5'" class="less" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/${compare()}.png`">
                        <div class="compare-data">
                            <p v-if="currentJobTab !== '2'">{{ getTheme('rightText1') }}</p>
                            <p v-else>
                                {{ currentGroupTab == '第4组' ? '第8名门店' : currentGroupTab == '第5组' ? '第1名门店' : '第10名门店' }}
                            </p>
                            <p>{{ getTheme('rightText2') }}</p>
                            <p class="blue" v-if="currentJobTab === '4' || currentJobTab === '5'">
                                {{ myInfo.netAmtMtd }}<span>W</span>
                                <span class="red fs-32">({{ myInfo.netAmtTargetPer }}%)</span>
                            </p>
                            <p class="blue" v-if="currentJobTab === '3'">
                                {{ myData }}<span>W</span>
                                <span class="red fs-32">({{ dataInfo.saleAmtBfSelfBcYoy }}%)</span>
                            </p>
                            <p class="red" v-if="currentJobTab === '1' || currentJobTab === '2'">{{ contrastData }}
                                <span v-if="currentJobTab === '1'">W</span>
                                <span v-else>%</span>
                            </p>
                        </div>
                    </div>
                    <p class="update-time">{{ getTheme('updateTime') }} {{ today }}{{ currentJobTab === '1' ? '0' : hour }}点</p>
                </template>
            </div>

            <div class="bg-color" :style="{ backgroundColor: getTheme('bgColor') }" v-if="!(currentJobTab === '3' && currentGroupMillionTab === '自我突破奖(非百万)' && currentGroupTab === 'A组')"></div>

            <div class="ranking-box">
                <div class="ranking-box-hd">
                    <div :class="{ on: isStore === 0 }" @click="onTabChange(0)">全部</div>
                    <div :class="{ on: isStore === 1 }" @click="onTabChange(1)">本店</div>
                </div>

                <div class="tabs-box">
                    <div class="job-tabs">
                        <div class="job-tab-item" :class="{ on: currentJobTab === it.dictValue }" v-for="it in jobTabs" :key="it.dictValue" @click="onJobTab(it.dictValue)">
                            {{ it.dictLabel }}
                        </div>
                    </div>
                    <div class="group-tabs" v-if="currentJobTab === '3'">
                        <div class="group-tab-item" :style="{ backgroundColor: currentGroupMillionTab === it ? getTheme('btnBgColor') : '#E6E6E6' }" :class="{ on: currentGroupMillionTab === it }" v-for="it in groupMillionTabs" :key="it" @click="onGroupMillionTab(it)">
                            {{ it }}
                        </div>
                    </div>
                    <div class="group-tabs" v-if="(currentGroupMillionTab === '自我突破奖(非百万)' && currentJobTab === '3') || currentJobTab !== '3'">
                        <div class="group-tab-item" :style="{ backgroundColor: currentGroupTab === it ? getTheme('btnBgColor') : '#E6E6E6' }" :class="{ on: currentGroupTab === it }" v-for="it in groupTabs" :key="it" @click="onGroupTab(it)">
                            {{ it }}
                        </div>
                    </div>
                </div>

                <div class="ranking-list-box">
                    <div class="ranking-list-item-box" v-if="myInfo">
                        <RankingItem :status="currentJobTab" :currentGroupMillionTab="currentGroupMillionTab" :item="myInfo" isMe :style="{ backgroundColor: getTheme('cardBgColor') }" />
                    </div>

                    <div class="ranking-list-item title">
                        <div class="ranking-num">排名</div>
                        <div class="ranking-name">{{ getTheme('title1') }}</div>
                        <div class="ranking-order" :class="{ 'ranking-orderT': currentJobTab !== '2' }">{{ getTheme('title2') }}</div>
                        <div class="ranking-order" v-if="currentJobTab === '2'">达成率</div>
                        <!-- <div class="ranking-order" v-else>
                            {{ currentGroupTab == '第5组' ? '达成率' : '非0护理客流同期比' }}
                        </div> -->
                        <div class="ranking-order" v-if="currentGroupMillionTab === '自我突破奖(百万)'">同比</div>
                        <div class="ranking-bonus" v-if="currentJobTab !== '3'">{{ getTheme('title3') }}</div>
                        <div class="ranking-bonus" v-else>
                            {{ currentGroupMillionTab == '百万大咖夺金奖' ? '获奖档位' : '预计获得奖金' }}
                        </div>
                    </div>

                    <RankingItem :status="currentJobTab" :currentGroupMillionTab="currentGroupMillionTab" :statusTab="currentGroupTab" :item="it" :index="it.rnk" v-for="(it, i) in list" :key="it.uniqueId" />
                </div>
            </div>
        </van-list>


        <!-- 规则弹框 -->
        <van-popup v-model="showRule" round>
            <div class="popup-rule">
                <div class="popup-rule-hd">活动规则</div>
                <div class="popup-main">
                    <div class="title">一、工作内容</div>
                    <div class="describe">
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                    </div>

                    <div class="title">二、任职资格</div>
                    <div class="describe">
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                    </div>
                </div>
            </div>
            <van-icon class="popup-close" name="close" size="40" color="#ffffff" @click="showRule = false" />
        </van-popup>

    </div>
</template>

<script>
    import request from '@/utils/request'
    import RankingItem from './rankingItem.vue'
    import { uniqueId, debounce } from 'lodash';
    import { getCookie } from '@/utils';

    export default {
        name: 'RankingList',
        components: {
            RankingItem
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                jobTabs: [], // 职位分类标签列表
                currentJobTab: '1', // ['美疗师', '技术监理', '客户经理', '主任', '区经']
                groupTabs: [], // 分组标签列表
                groupMillionTabs: ['自我突破奖(非百万)', '自我突破奖(百万)', '百万大咖夺金奖'], // 分组标签列表
                currentGroupTab: '第1组', // 当前选中的分组
                currentGroupMillionTab: '自我突破奖(非百万)', // 当前选中的分组
                loading: false, // 是否正在加载
                finished: false, // 是否加载完成
                list: [], // 排名列表数据
                isStore: 0, // 当前选中的tab
                page: 1, // 当前页码
                today: new Date().getMonth() + 1 + '月' + new Date().getDate() + '日', // 当前日期，格式为"月日"
                hour: new Date().getHours(), // 当前小时数
                error: false, // 是否发生错误
                myInfo: {}, // 当前用户的数据
                isAward: false, // 是否获奖
                isReach: false, // 是否达到目标
                isMillion: '0', // 是否是百万大咖
                dataInfo: {},
                isEnd: new Date().getTime() > new Date('2025-12-31 23:59:59').getTime(), // 活动是否已结束
                contrastData: 0, // 对比数据，用于与当前用户数据进行对比
                myData: 0,// 当前用户的数据，用于展示用户自身排名信息
                postId: '', // 员工id
                businessType: '1', // 业务类型1- 自我突破（非百万），2 - 自我突破（百万），3 - 百万大咖
                // 员工id列表, 分别对应['美疗师', '技术监理', '客户经理', '主任', '区经']
                postIdList: [['7'], ['4'], ['2', '42'], ['1'], ['11', '1472787652026765457', '1472787652026765732']],
                role: '', // 当前用户的角色
            }
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.postIdList.forEach((it, i) => {
                if (it.includes(this.postId)) {
                    this.role = i + 1 + ''
                }
            })
            if (!this.role) {
                this.$dialog.alert({
                    title: '提示',
                    message: '当前用户暂无权限, 请返回',
                }).then(() => {
                    this.$router.back()
                });
                return
            }

            this.currentJobTab = this.role
            this.getjobTabs()
        },
        methods: {
            // 初始化数据，获取销售列表
            getDataList: debounce(async function (reset) {
                if (this.finished) return
                try {
                    const params = {
                        groupNo: this.currentGroupTab,
                        isStore: this.isStore,
                        type: this.currentJobTab,
                        businessType: this.currentJobTab === '3' ? this.businessType : '',
                        page: this.page
                    }
                    const { msg, data } = await request({
                        url: '/sm/new-year/ranking/getRankingInfoPage',
                        method: 'get',
                        params
                    })
                    if (msg !== 'success') {
                        throw new Error(msg)
                    }
                    this.dataInfo = data || {}
                    let list = data[this.getTheme('list')]
                    this.myInfo = data[this.getTheme('info')]
                    list = list.map(it => {
                        it.uniqueId = uniqueId()
                        return it
                    })
                    // this.list直接赋值, 不置空, 防止页面高度丢失导致闪屏
                    if (this.page === 1) {
                        this.list = list
                        this.resetList = false
                    } else {
                        this.list = [...this.list, ...list]
                    }
                    this.isAward = data.isAward * 1
                    this.isReach = data.isReach * 1
                    this.contrastData = data.contrastData
                    this.myData = data.myData

                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = true;
                    this.$toast(error)
                }

            }, 500),
            // 获取职位分类标签
            async getjobTabs() {
                const { data } = await request({
                    url: '/dict/type/dictList',
                    method: 'get',
                    params: { dictType: 'sm_dep_list' }
                })

                this.jobTabs = data.filter((it, i) => {
                    if (this.role === '1') {
                        return i < 2
                    }
                    if (this.role === '2' || this.role === '3') {
                        return i < 3
                    }
                    if (this.role === '4') {
                        return i < 4
                    }
                    if (this.role === '5') {
                        return true
                    }
                })
                this.getGroupTab()
            },
            // 获取分组标签
            async getGroupTab() {
                const { data } = await request({
                    url: '/sm/new-year/ranking/getGroupNoTab',
                    method: 'get',
                    params: { type: this.currentJobTab }
                })
                this.isMillion = data ? data.isMillion : '0'
                this.groupTabs = data && data.list && data.list.length > 0 ? data.list : []
                this.currentGroupTab = data && data.groupNo ? data.groupNo : data && data.list[0] // 默认选中

                this.businessType = this.isMillion === '0' ? '1' : '2'
                if (this.role === '3') {
                    this.groupMillionTabs = this.isMillion === '0' ? ['自我突破奖(非百万)', '百万大咖夺金奖'] : ['自我突破奖(百万)', '百万大咖夺金奖']
                }
                this.currentGroupMillionTab = this.isMillion === '0' ? '自我突破奖(非百万)' : '自我突破奖(百万)'
                this.getDataList()
            },
            onLoad() {
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                if (this.currentJobTab === value) return
                if (value === '5' && this.isStore === 1) {
                    this.$toast('区经无法选择本店!')
                    return
                }
                this.currentGroupMillionTab = '自我突破奖(非百万)'
                this.currentJobTab = value;
                this.page = 1
                this.finished = false
                this.error = false;
                // this.isStore = 0
                this.isEnd = new Date().getTime() > new Date('2025-12-31 23:59:59').getTime()
                if (value === '3') {
                    this.isEnd = new Date().getTime() > new Date('2026-01-03 23:59:59').getTime()
                }
                this.getGroupTab()
            },

            // 切换客户经理百万突破分组标签
            onGroupMillionTab(value) {
                if (this.currentGroupMillionTab === value) return
                this.currentGroupMillionTab = value;
                this.businessType = value === '自我突破奖(非百万)' ? '1' : value === '自我突破奖(百万)' ? '2' : '3'
                this.finished = false
                this.error = false;
                this.page = 1
                if (value === '自我突破奖(非百万)' && (this.role === '4' || this.role === '5' || this.role === '2')) {
                    this.currentGroupTab = this.groupTabs[0]
                }

                this.getDataList()

            },
            // 切换分组标签
            onGroupTab(value) {
                if (this.currentGroupTab === value) return
                this.currentGroupTab = value;
                this.finished = false
                this.error = false;
                this.page = 1

                this.getDataList()

            },
            // 切换全部/本店标签
            onTabChange(value) {
                if (this.isStore === value) return
                if (this.currentJobTab === '5') {
                    this.$toast('区经无法选择本店!')
                    return
                }
                this.isStore = value;
                this.finished = false
                this.error = false;
                this.page = 1

                this.getDataList()
            },
            compare() {
                return Number(this.myData) > Number(this.contrastData) ? 'more' : this.myData === this.contrastData ? 'equal' : 'less'
            },
            // 获取主题色和图片和文字
            getTheme(type) {
                if (this.jobTabs.length === 0) return
                const index = this.jobTabs.findIndex(it => it.dictValue === this.currentJobTab);
                const theme = {
                    bgColor: ['#F65131', '#F65131', '#90002C', '#BB1E21', '#BB1E21'],
                    btnBgColor: ['#AB080B', '#AB080B', '#B07626', '#844FC7', '#844FC7'],
                    cardBgColor: ['#FDE3D7', '#FDE3D7', '#FBE2BE', '#FFE7E7', '#FFE7E7'],
                    bannerImg: ['bannerBeauty', 'bannerSkill', 'bannerManager', 'bannerDirector', 'bannerArea'],
                    rewardImg: ['bg11', 'bg11', 'bg33', 'bg45', 'bg45'],
                    ruleImg: ['rule1', 'rule1', 'rule2', 'rule3', 'rule3'],
                    leftText1: ['我的', '我的门店', '我的', '我的门店', '我的区域'],
                    leftText2: ['当前自营护理开单额', '当前非0护理客流达成率', '2024年产品销售额', '当前权益金', '当前权益金'],
                    rightText1: ['第20名美疗师', '第10名门店', '我的', '我的门店', '我的区域'],
                    rightText2: ['当前自营护理开单额', '当前非0护理客流达成率', '2025年产品销售额', '当前营业收入', '当前营业收入'],
                    updateTime: ['护理开单额数据更新时间', '非0护理客流数据更新时间', '护理销售额数据更新时间', '权益金、营业收入数据更新时间', '权益金、营业收入数据更新时间'],
                    // rewardText1: ['组内前20名', `组内前${this.getGroupBonus('rewardText1_1')}名`, '组内前15名', '根据3+4权益金贡献', '根据3+4权益金贡献'],
                    // rewardText2: [`瓜分<span class="red">${this.getGroupBonus('rewardText2_1')}元</span>奖金`, '奖励<span class="red">800元</span>现金', `获得<span class="red">${this.getGroupBonus('rewardText2_3')}元</span>现金`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_4')}元</span>奖金池`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_5')}元</span>奖金池`],
                    title1: ['美疗师', '门店', '客户经理', '主任', '区经'],
                    title2: ['开单额', '客流', '产品销售额 ', '权益金', '权益金'],
                    title3: ['预计瓜分奖金', '预计获得奖金', '预计获得奖金', '预计瓜分奖金', '预计瓜分奖金'],
                    achieve: ['2025年11+12月门店非0护理开单客流当前进度', '2025年11+12月门店非0护理客流、营业收入', '2025年11+12月门店护理销售额当前进度', '2025年11+12月门店权益金、营业收入当前进度', '2025年11+12月区域权益金、营业收入当前进度'],
                    list: ['mlsSalekpiList', 'jsjlSalekpiList', 'empSalekpiList', 'dirctSalekpiList', 'managerSalekpiList'],
                    info: ['mlsSalekpi', 'jsjlSalekpi', 'empSalekpi', 'dirctSalekpi', 'managerSalekpi']

                }
                return theme[type][index];
            },
            // 将二次套娃的单独拿出来, 减少代码触发判断的次数
            getThemeBonus(type) {
                if (this.groupTabs.length === 0 || this.jobTabs.length === 0) return 0
                const index = this.jobTabs.findIndex(it => it.dictValue === this.currentJobTab);
                const theme = {
                    rewardText1: ['组内前20名', `组内前${this.getGroupBonus('rewardText1_1')}名`, '组内前15名', '根据11+ 12月权益金贡献', '根据11+ 12月权益金贡献'],
                    rewardText2: [`瓜分<span class="red bold font30">${this.getGroupBonus('rewardText2_1')}元</span>/奖金`, '奖励<span class="red">800元</span>现金', `获得<span class="red">${this.getGroupBonus('rewardText2_3')}元</span>现金`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_4')}元</span>奖金池`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_5')}元</span>奖金池`],
                }
                return theme[type][index];
            },
            // 根据分组展示不同的数据
            getGroupBonus(type) {
                const index = this.groupTabs.findIndex(it => it === this.currentGroupTab)
                const theme = {
                    rewardText2_1: [15000, 12000, 8000, 8000, 8000],
                    rewardText1_1: [10, 10, 10, 8, 1],
                    rewardText2_3: [1600, 1400, 1200, 1000],
                    top16_30: [800, 600, 400, 200],
                    rewardText2_4: [12000, 25000, 20000, 15000],
                    rewardText2_5: [20000, 15000, 10000],
                }
                return theme[type][index]
            },
            toRule() {
                this.$router.push({ path: '/Rule' })
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;

        .bold {
            font-weight: bolder;
        }

    }

    .banner {
        width: 100%;
        height: 464px;
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
    }

    .reward-box {
        position: relative;
        width: 100%;
        // height: 860px;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;

        .reward-status {
            width: 100%;
            margin-bottom: 30px;
        }

        .reach {
            font-size: 28px;
        }

        .baseHeight1 {
            height: 349px;
        }

        .baseHeight2 {
            height: 349px;
        }

        .baseHeight3 {
            height: 417px;
        }

        .baseHeight4,
        .baseHeight5 {
            height: 348px;
        }
    }

    .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 350px;
        padding-bottom: 30px;
        padding-top: 80px;
        margin-bottom: 30px;
        // background-image: url('https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/bg.png');
        background-size: 100% 100%;

        &.left {
            padding-right: 30px;
            padding-left: 20px;

            .reward-data:nth-of-type(1) {
                flex: 1.7;
            }
        }

        .reward-data {
            flex: 1;
            text-align: center;

            >img {
                height: 150px;
            }
        }
    }

    .reward-img {
        display: flex;
        width: 100%;
        margin-bottom: 30px;

        img {
            width: 100%;
        }
    }



    .compare {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;

        .less {
            width: 40px;
            height: 40px;
        }

        .compare-data {
            width: 45%;

            p {
                margin-bottom: 10px;
            }

            p:first-child {
                font-size: 36px;
                margin-top: 3px;
            }

            p:nth-child(2) {
                font-size: 24px;
            }

            p:last-child {
                font-size: 46px;
                font-weight: 500;
            }
        }
    }

    .compare-center {
        justify-content: center;
    }

    .update-time {
        font-size: 24px;
        color: #999999;
    }

    .fs-32 {
        font-size: 32px;
    }

    .blue {
        color: #007AFF;
        font-weight: 500;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }

    .ranking-box-hd {
        display: flex;

        >div {
            width: 50%;
            line-height: 100px;
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            color: #999999;
            background-color: #F5F5F5;

            &.on {
                color: #333333;
                background-color: #ffffff;
            }
        }
    }

    .tabs-box {
        padding: 0 30px;
    }

    .job-tabs {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        padding: 30px 0;
        font-weight: 500;


        &.on {
            position: relative;
            color: #333333;

            // &::before {
            //     position: absolute;
            //     content: '';
            //     left: 50%;
            //     bottom: 20px;
            //     width: 40px;
            //     height: 6px;
            //     transform: translate(-50%);
            //     background-color: #333333;
            //     border-radius: 4px;
            // }
        }
    }

    .group-tabs {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        overflow-x: scroll;
        white-space: nowrap;
    }

    .group-tab-item {
        height: 40px;
        padding: 0 30px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;

        &.on {
            color: #ffffff;
            background-color: #AB080B;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }

    .ranking-list-item-box {
        padding: 0 20px;
    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 60px;
        margin-right: 40px;

        .color-red {
            color: #AB080B;
        }

        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {
        display: flex;
        align-items: center;
        width: 240px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        width: 100px;
        text-align: center;
    }

    .ranking-orderT {
        width: 140px;
    }

    .ranking-bonus {
        width: 130px;
        text-align: center;
    }



    .popup-rule {
        width: 650px;
        padding-bottom: 30px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
    }

    .popup-rule-hd {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
        font-size: 36px;
        font-weight: 500;
        background-image: linear-gradient(#CEDBF0, #ffffff);
    }

    .popup-main {
        height: 600px;
        overflow-y: scroll;

        >.title {
            padding: 20px 40px;
            font-size: 28px;
            font-weight: 500;
        }

        >.describe {
            padding: 0 60px;
            font-style: 24px;
            color: #66757F;
            line-height: 46px;
        }
    }

    .popup-close {
        position: absolute;
        left: 50%;
        bottom: -90px;
        transform: translate(-50%);
    }

    .bg-color {
        height: 90px;
        margin: -30px 0;
    }
</style>
<style lang="less">
    .ranking {
        .red {
            color: #D41D16;
        }

        .bold {
            font-weight: bold !important;
        }

        .font30 {
            font-size: 30px;
        }

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>